import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { AnalyticsService, EVENT_CONSTANTS, EVENTS } from '@/services';

import { PageContainer } from '../components';
import { FormVariants, RegisterForm } from './RegisterForm';

export const RegisterPage = () => {
  useEffect(() => {
    AnalyticsService.logEvent(EVENTS.MARKETING_EVENTS.SIGNUP_VIEWED);
  }, []);

  const { search } = useLocation();

  const formVariant = useMemo(() => {
    const searchParams = new URLSearchParams(search);
    const variant = searchParams.get('variant')?.toLocaleLowerCase() as
      | (typeof FormVariants)[keyof typeof FormVariants]
      | undefined;
    return Object.values(FormVariants).includes(
      variant as (typeof FormVariants)[keyof typeof FormVariants],
    )
      ? variant
      : undefined;
  }, [search]);

  return (
    <PageContainer variant={formVariant}>
      <RegisterForm
        referrer={{ page: EVENT_CONSTANTS.PAGE.REGISTER }}
        variant={formVariant}
      />
    </PageContainer>
  );
};
